export default __webpack_public_path__ + "static/media/WWG3.b341df98.jpg";